import './index.scss';

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', event => {
    const targetId = (event.currentTarget as HTMLAnchorElement).getAttribute('href') ?? '';
    const target = targetId ? document.querySelector(targetId) : null;

    if (target) {
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});

document.querySelectorAll<HTMLAnchorElement>('[data-copy-email]').forEach(button => {
  button.addEventListener('click', async event => {
    event.preventDefault();
    const email = button.getAttribute('data-copy-email');
    if (!email) return;

    try {
      await navigator.clipboard.writeText(email);
      button.dataset.copied = 'true';
      button.textContent = 'Email copied';
      window.setTimeout(() => {
        button.dataset.copied = 'false';
        button.textContent = email;
      }, 1800);
    } catch {
      window.location.href = `mailto:${email}`;
    }
  });
});
